import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=54417225&scoped=true&"
import script from "./MobileSidebar.vue?vue&type=script&lang=js&"
export * from "./MobileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MobileSidebar.vue?vue&type=style&index=0&id=54417225&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54417225",
  null
  
)

export default component.exports